import { Link } from "react-router-dom";
import { Sparkles, Briefcase, Wallet, FolderLock, ArrowRight } from "lucide-react";

/* IndianAirports → TravelerPulse cross-promo strip (traffic channeling).
   Every link carries ?ref=indianairports so TP traffic from IA is measurable. */

const OFFERS = [
  { icon: Sparkles, title: "AI Trip Planner", desc: "A day-by-day plan for your destination in seconds", to: "/plan-ai?ref=indianairports", testid: "ia-promo-planai" },
  { icon: Briefcase, title: "My Travel Hub", desc: "Flights, PNRs, documents and notes — one trip record", to: "/travel-hub?ref=indianairports", testid: "ia-promo-hub" },
  { icon: Wallet, title: "Expense Manager", desc: "Track every trip rupee, split with co-travelers", to: "/expenses?ref=indianairports", testid: "ia-promo-expenses" },
  { icon: FolderLock, title: "Document Locker", desc: "Passports, visas and tickets — safe and shareable", to: "/locker?ref=indianairports", testid: "ia-promo-locker" },
];

export default function IAPromoStrip({ city }) {
  // src tells the ref-traffic dashboard which IA page sent the visitor
  const src = `&src=${encodeURIComponent(window.location.pathname)}`;
  return (
    <div className="bg-zinc-900 rounded-2xl p-5 sm:p-6" data-testid="ia-promo-strip">
      <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
        <span className="font-heading font-900 text-white text-lg">Travel smarter with <span className="text-sky-400">TravelerPulse</span>.pro</span>
        <span className="text-xs text-zinc-400">Free tools for your {city ? `${city} trip` : "journey"} — from the team behind IndianAirports.com</span>
      </div>
      <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {OFFERS.map(({ icon: Icon, title, desc, to, testid }) => (
          <Link key={title} to={to + src} data-testid={testid}
            className="group bg-zinc-800/80 border border-zinc-700 rounded-xl p-3.5 hover:border-sky-500 transition-colors">
            <Icon className="w-4 h-4 text-sky-400" />
            <div className="mt-2 text-sm font-800 text-white flex items-center gap-1">{title}
              <ArrowRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" /></div>
            <p className="mt-0.5 text-[11px] text-zinc-400 leading-snug">{desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
